import * as React from 'react';
import {Outlet, useParams} from 'react-router';
//import {getBlogPosts} from '@nls-2022/nls-api/dist/blog/getBlog';
//import useBlogPosts from '../../hooks/useBlogPosts';
import {useBlogDetails, useClubs} from '@nls-2022/nls-bll';
import {BlogManagerRoutes} from '../../routes/BlogManagerRoutes';
import {BlogManagerNav} from '../../components/blog/BlogManagerNav';
import {BlogManagerNewTemplateList} from '../../components/blog/BlogManagerNewTemplateList';
import {ProcessingStatusType} from '@nls-2022/nls-bll';
import {
  BlogPostsAction,
  BlogPostsState,
  BlogPostsActionType,
  ClubsState,
} from '@nls-2022/nls-bll';
import {ClubSearchAction} from '@nls-2022/nls-api';
export type BlogManagerProps = {
  children?: React.ReactNode;
};

export const BlogPostsContext = React.createContext<{
  state: BlogPostsState;
  dispatchBlogPosts: React.Dispatch<BlogPostsAction>;
}>({
  state: {
    blogPostsStatus: ProcessingStatusType.warning,
    blogPosts: undefined,
  },
  dispatchBlogPosts: () => undefined,
});

export const ClubsContext = React.createContext<{
  clubsState: ClubsState;
  dispatchClubs: React.Dispatch<ClubSearchAction>;
}>({
  clubsState: {
    clubStatus: ProcessingStatusType.warning,
    clubs: undefined,
  },
  dispatchClubs: () => undefined,
});

const BlogManagerContainer = ({children}: BlogManagerProps): JSX.Element => {
  //const [{blogPosts, blogPostsStatus}, dispatch] = useBlogPosts();
  const [state, dispatchBlogPosts] = useBlogDetails();
  const [clubsState, dispatchClubs] = useClubs();
  const blogPostsContextProviderValue = {state, dispatchBlogPosts};
  const clubsContextProviderValue = {clubsState, dispatchClubs};
  return (
    <>
      <h2>
        Blog Manager{' '}
        <span data-testid="blog-post-count">{state.blogPosts?.length}</span>{' '}
        <span>{state.blogPostsStatus}</span>
      </h2>
      <BlogManagerNav />
      <ClubsContext.Provider value={clubsContextProviderValue}>
        <BlogPostsContext.Provider value={blogPostsContextProviderValue}>
          <Outlet />
        </BlogPostsContext.Provider>
      </ClubsContext.Provider>
    </>
  );
};

export default BlogManagerContainer;
